import { render, staticRenderFns } from "./DossierErreur.vue?vue&type=template&id=05f35bf5&scoped=true&"
import script from "./DossierErreur.vue?vue&type=script&lang=js&"
export * from "./DossierErreur.vue?vue&type=script&lang=js&"
import style0 from "./DossierErreur.vue?vue&type=style&index=0&id=05f35bf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f35bf5",
  null
  
)

export default component.exports